(function () {
  'use strict';

  function setActiveThumb(thumbsRoot, activeLi) {
    if (!thumbsRoot || !activeLi) return;
    thumbsRoot.querySelectorAll('li').forEach(function (li) {
      li.classList.remove('is-active', 'active');
      var btn = li.querySelector('button[data-image], a[data-image]');
      if (btn) btn.setAttribute('aria-current', 'false');
    });
    activeLi.classList.add('is-active');
    var control = activeLi.querySelector('button[data-image], a[data-image]');
    if (control) control.setAttribute('aria-current', 'true');
  }

  function clearVideo(stage, featured) {
    if (!stage) return;
    var video = stage.querySelector('.vf-product-gallery__video');
    if (video) video.remove();
    if (featured) featured.style.display = 'block';
  }

  function swapFeaturedImage(root, featured, src, zoomSrc) {
    if (!featured || !src) return;
    clearVideo(root.querySelector('.vf-product-gallery__stage'), featured);
    featured.src = src;
    featured.removeAttribute('srcset');
    if (zoomSrc) {
      featured.setAttribute('data-zoom-image', zoomSrc);
      var lightbox = root.querySelector('[data-vf-gallery-lightbox]');
      if (lightbox) lightbox.setAttribute('href', zoomSrc);
    }
  }

  function injectYoutube(stage, featured, videoId) {
    if (!stage || !featured || !videoId) return;
    featured.style.display = 'none';
    var existing = stage.querySelector('.vf-product-gallery__video');
    var html =
      '<div class="vf-product-gallery__video">' +
      '<iframe src="https://www.youtube.com/embed/' +
      encodeURIComponent(videoId) +
      '?autoplay=1" title="Video del servicio" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>' +
      '</div>';
    if (existing) {
      existing.outerHTML = html;
    } else {
      stage.insertAdjacentHTML('beforeend', html);
    }
  }

  function initGallery(root) {
    var featured = root.querySelector('#product-featured-image');
    var thumbsRoot = root.querySelector('#ProductThumbs');
    var stage = root.querySelector('.vf-product-gallery__stage');
    if (!featured || !thumbsRoot) return;

    thumbsRoot.addEventListener('click', function (event) {
      var control = event.target.closest('button[data-image], a[data-image]');
      if (!control || !thumbsRoot.contains(control)) return;

      if (control.tagName === 'A' && control.classList.contains('vf-product-gallery__thumb--link')) {
        return;
      }

      event.preventDefault();

      var li = control.closest('li');
      var videoSrc = control.getAttribute('data-video-src');

      if (videoSrc) {
        injectYoutube(stage, featured, videoSrc);
        setActiveThumb(thumbsRoot, li);
        return;
      }

      var src = control.getAttribute('data-image');
      var zoom = control.getAttribute('data-zoom-image');
      swapFeaturedImage(root, featured, src, zoom);
      setActiveThumb(thumbsRoot, li);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-vf-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
